<template>
  <v-navigation-drawer v-model="dialogValue" absolute right temporary width="500">
    <v-toolbar dark color="secondary">
      <v-btn icon dark @click="dialogValue = false">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Roles</v-toolbar-title>
    </v-toolbar>
    <v-alert :value="alertMessage" type="error">
      <ul v-if="Array.isArray(alertMessage)">
        <li v-for="(message, index) in alertMessage" :key="index">
          {{ message }}
        </li>
      </ul>
      <div v-else>
        {{ alertMessage }}
      </div>
    </v-alert>
    <div v-if="user" class="py-5 px-4">
      <p class="headline mb-1">
        {{ user.fullName }}
      </p>
      <p class="subheading">
        {{ user.email }}
      </p>
      <v-autocomplete v-model="selectedCompany" class="pt-5" :items="companiesSelectList" item-text="name" item-value="id" label="Select a Company" />
      <v-fade-transition mode="out-in">
        <div v-if="loading" key="1" class="pt-5 text-xs-center">
          <v-progress-circular :size="70" :width="7" color="secondary" indeterminate />
        </div>
        <div v-else key="2" class="pt-3 px-4">
          <div v-if="systemRoles.length == 0" class="text-xs-center">
            No roles were found for this company.
          </div>
          <div v-for="role in systemRoles" v-else :key="role.id">
            <v-checkbox v-model="userRoles" :value="role.id" hide-details @change="changeUserRole(role.id, $event)">
              <div slot="label">
                {{ role.name }}
                <v-tooltip v-show="role.description" bottom max-width="300px" content-class="text-xs-center" style="position: relative;top: -6px;">
                  <v-icon slot="activator" small>
                    help
                  </v-icon>
                  <span v-text="role.description" />
                </v-tooltip>
              </div>
            </v-checkbox>
          </div>
        </div>
      </v-fade-transition>
    </div>
  </v-navigation-drawer>
</template>

<script>

  import axios from 'axios';

  export default {
    props: {
      user: {
        type: Object,
        default: () => { },
      },

      dialog: {
        type: Boolean,
        default: false,
      },

      companies: {
        type: Array,
        default: () => [],
      },
    },

    data: () => ({
      superAdmin: window.superAdmin,
      saving: false,
      selectedCompany: null,
      loading: false,
      userRoles: [],
      systemRoles: [],
    }),

    computed: {
      dialogValue: {
        get() {
          return this.dialog;
        },
        set(value) {
          this.$emit('update:dialog', value);
        },
      },

      companiesSelectList() {
        const companies = JSON.parse(JSON.stringify(this.companies));
        if (this.superAdmin) {
          companies.unshift({ id: null, name: 'All Companies' });
        } else {
          this.selectedCompany = companies[0].id;
        }
        return companies;
      },
    },

    watch: {
      selectedCompany() {
        this.getSystemRoles();
      },

      dialogValue(val) {
        if (val) {
          this.clearErrors();
          this.getSystemRoles();
        }
      },
    },

    methods: {
      async getUserRoles() {
        const endParam = this.selectedCompany ? `/${this.selectedCompany}` : '';
        const { data } = await axios.get(`/api/system/user-management/users/${this.user.id}/roles${endParam}`);
        this.userRoles = data.map(a => a.id);
      },

      async getSystemRoles() {
        this.loading = true;
        const endParam = this.selectedCompany ? `?companyId=${this.selectedCompany}` : '';
        const { data } = await axios.get(`/api/system/user-management/users/roles${endParam}`);
        this.systemRoles = data;
        await this.getUserRoles();
        this.loading = false;
      },

      async changeUserRole(roleId, event) {
        try {
          // If it exists in client array, then add to the server.
          if (event.find(m => m === roleId)) {
            await axios.post(`/api/system/user-management/users/${this.user.id}/roles?companyId=${this.selectedCompany}&roleId=${roleId}`);
          } else {
            await axios.delete(`/api/system/user-management/users/${this.user.id}/roles?companyId=${this.selectedCompany}&roleId=${roleId}`);
          }
        } catch (error) {
          this.processErrors(error);
        }
      },
    },
  };
</script>